import { get, isMockMode, simulateDelay } from "../api";

export const getOfferingTypes = () => {
	if (isMockMode()) {
		const testData = [
			{
				typeId: 0,
				typeName: "Product",
			},
			{
				typeId: 50,
				typeName: "Service",
			},
		];

		return simulateDelay(50, () => testData);
	}

	return get(`discover/getOfferingTypes`);
};
